<template lang="pug">
  section.article-header
    .jumbo
      .mask
        VideoPlayer(v-if="video" :video="video")
        img(v-if="img && !video" :src="img" :alt="title", :style="`object-position: ${alignment}`")
    .wrap
      header
        h2.title
          small(v-if="beforetitle") {{beforetitle}}
          span(v-html="title")
          small(v-if="aftertitle") {{aftertitle}}
        h4.under(v-if="undertitle") {{undertitle}}
        span.more(v-if="more") ver más
</template>
<script>
import VideoPlayer from '@/components/VideoPlayer'
export default {
  props: {
    title: String,
    undertitle: String,
    beforetitle: String,
    aftertitle: String,
    img: String,
    more: Boolean,
    hovered: Boolean,
    alignment: String,
    video: String
  },
  components: {
    VideoPlayer
  },
  computed: {
    brTitle(){
      const ttext = this.title.trim();
      return ttext.replace(' ', '<br>')
    },
  }
}
</script>
<style lang="scss" scoped>
  // header{
  //   height: 90vh;
  //   overflow: hidden;
  //   position: relative;
  //   .mask{
  //     img{
  //       opacity: 0.8;
  //       transition: all .3s;
  //     }
  //     background-image: linear-gradient(to bottom right,#002f4b,#dc4225);
  //   }
  //   @media (max-width: 900px){
  //     height: 90vh;

  //   }
  //   @media (max-width: 600px){
  //     height: 90vh;
  //   }
  //   img{
  //     width: 100%;
  //     height: 100vh;
  //     object-fit: cover;
  //   }
  // }

  // .block,
  // header,
  // .title{
  //   max-width: $maxwidth;
  //   margin-left: auto;
  //   margin-right: auto;
  //   @media (max-width: 800px){
  //     padding: 0 1rem;
  //     max-width: 100%;
  //   }
  // }
  // .title{
  //   margin-bottom: 2rem;
  // }
  // h2{
  //   @include fluid-type(360px,
  // 1440px,
  // 42px,
  // 96px);
  //   text-align: center;
  //   margin-bottom: 2rem;
  //   color: white;
  //   @media (max-width: 800px){
  //     margin-bottom: 1rem;
  //   }
  //   small{
  //     display: block;
  //     @include fluid-type(360px,
  //     1440px,
  //     26px,
  //     32px);
  //   }
  // }
  // h4{
  //   @include fluid-type(360px,
  //   1440px,
  //   26px,
  //   32px);
  // }
  // .content-title{
  //   position: absolute;
  //   z-index: 3;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   padding-bottom: 3rem;
  //   text-align: center;
  //   color: white;
  //   @media(max-width: 800px){
  //     padding-bottom: 0;
  //   }
  //   header{
  //     max-width: 480px;
  //     margin-left: auto;
  //     margin-right: auto;
  //     padding: 1rem;
  //   }
  // }
  // span.more{
  //   padding: 1rem;
  //   display: block;
  //   &:after{
  //     content: '→';
  //     padding-left: 0.3rem;
  //     transition: all .3s;
  //   }
  // }
  // .section{
  //   &:hover{
  //     span.more{
  //       &:after{
  //         padding-left: 1rem;
  //       }
  //     }
  //     .mask{
  //       img{
  //         opacity: 1;
  //         transform: scale(1.008);
  //       }
  //     }
  //   }
  // }




</style>

